/* eslint-disable */
/* TODO: If you edit this file remove eslint-disable and fix linting errors in this file. */
require('fullcalendar/dist/fullcalendar.css');
const jQuery = require('jquery');
require('fullcalendar');
window.jQuery = window.$ = jQuery;
require('./emojiPicker');
require('jquery-waypoints/waypoints');
